import React from "react";
import MUILink, { LinkProps } from "@mui/material/Link";

export const Link: React.FC<LinkProps> = ({ sx, ...props }) => (
  <MUILink
    {...props}
    sx={[
      { cursor: "pointer" },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

export type { LinkProps };
